/* Carte produit : swipe des photos sur mobile (accueil + collections).
   Délégation sur le document, pour survivre au rechargement de la grille par les filtres. */
(function () {
  if (window.cardSwipeInit) return;
  window.cardSwipeInit = true;

  function majFleches(media) {
    var conteneur = media.parentElement;
    var fin = media.scrollLeft + media.clientWidth >= media.scrollWidth - 4;
    conteneur.classList.toggle('is-fin', fin);
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var media = event.target;
      if (media.classList && media.classList.contains('media--swipe')) majFleches(media);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var fleche = event.target.closest('.card-swipe__fleche');
    if (fleche) {
      event.preventDefault();
      event.stopPropagation();
      var media = fleche.parentElement.querySelector('.media--swipe');
      if (!media) return;
      if (fleche.classList.contains('card-swipe__fleche--precedente')) {
        media.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        media.scrollBy({ left: media.clientWidth, behavior: 'smooth' });
      }
      return;
    }

    var swipe = event.target.closest('.media--swipe');
    if (swipe && swipe.dataset.href) window.location.href = swipe.dataset.href;
  });
})();
